/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mTransaction.vue?vue&type=template&id=5a542cb2"
import script from "./mTransaction.vue?vue&type=script&lang=js"
export * from "./mTransaction.vue?vue&type=script&lang=js"
import style0 from "./mTransaction.vue?vue&type=style&index=0&id=5a542cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports